import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

import { AppModel } from '../models/app.model';

@Injectable()
export class NotificationService {
  public _connectApp: Subject<AppModel> = new Subject();
  public connectApp$ = this._connectApp.asObservable();

  public updateConnectApp(appModel: AppModel): void {
    this._connectApp.next(appModel);
  }
}
